import 'slick-carousel';

import { breakpointAtLeast, videoLoad } from './utils';

(function ($) {
  /* regular slider */
  if ($('.js-banner-slider').length) {
    $('.js-banner-slider').each(function () {
      var $bannerSlider = $(this);

      // Get all banner videos
      var $allVideos = $bannerSlider.find('video');

      // Load videos, only on devices larger than 'medium'
      $.each($allVideos, function (index, value) {
        var $currentVideo = $(this);

        if ($currentVideo.length) {
          // Load video on resize
          $(window).on(
            'resize',
            throttle(function () {
              videoLoad($currentVideo);
            }, 10),
          );

          // Load video on page load
          videoLoad($currentVideo);

          // Append listener when video is ended
          videoEndedListener($bannerSlider, $currentVideo);
        }
      });

      var bannerSliderArgs = {
        // lazyLoad: 'ondemand',
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        dots: false,
        speed: 1500,
        draggable: false,
        nextArrow: $bannerSlider.parent().find('.js-banner-slider-next'),
        prevArrow: $bannerSlider.parent().find('.js-banner-slider-prev'),
        responsive: [
          {
            breakpoint: 480,
            settings: {
              draggable: true,
              arrows: false,
            },
          },
        ],
      };

      // Enable dots when there is wrapper for them
      if ($('.js-banner-slider-dots').length > 0) {
        bannerSliderArgs.dots = true;
        bannerSliderArgs.appendDots = '.js-banner-slider-dots';
      }

      // Initialize slick
      $bannerSlider.slick(bannerSliderArgs);

      // If first slide contains video, we need to play it separately ('afterChange' event has not run yet)
      var $firstSlide = $bannerSlider.find('.slick-slide')[0];
      if ($($firstSlide).find('video').length > 0) {
        var $currentVideo = $($firstSlide).find('video');
        slickVideoPlay($bannerSlider, $currentVideo);
      }

      // Play video after slide is changed
      $bannerSlider.on('afterChange', function (event, slick, currentSlide) {
        var $currentVideo = slickGetCurrentSlideVideo($bannerSlider);

        if ($currentVideo.length > 0) {
          slickVideoPlay($bannerSlider, $currentVideo);
          $currentVideo.get(0).play();
        }
      });

      // Pause video before slide is changed
      $bannerSlider.on('beforeChange', function (event, slick, currentSlide) {
        var $currentVideo = slickGetCurrentSlideVideo($bannerSlider);

        if ($currentVideo.length > 0) {
          $currentVideo.get(0).pause();
        }
      });
    });
  }

  /**
   * Append listener to "ended" video event to pause slider.
   *
   * @link https://stackoverflow.com/questions/31521763/slick-js-and-html5-video-autoplay-and-pause-on-video
   */
  function videoEndedListener($bannerSlider, $currentVideo) {
    // We need to get JS oject and continue slick play
    $currentVideo.get(0).addEventListener(
      'ended',
      function () {
        $bannerSlider.slick('slickPlay');
        $bannerSlider.slick('slickNext');
        // console.log('video ended');
      },
      false,
    );
  }

  /**
   * Get jquery video object from current slide
   */
  function slickGetCurrentSlideVideo($bannerSlider) {
    return $bannerSlider.find('.slick-current').find('video');
  }

  /**
   * Check if current slide has video, pause slider and play video.
   */
  function slickVideoPlay($bannerSlider, $currentVideo) {
    if ($bannerSlider.find('.slick-current').find($currentVideo).length > 0) {
      $bannerSlider.slick('slickPause');
      $currentVideo.get(0).play();
    }
  }

  // Social slider used on HP
  if ($('.js-social-slider').length) {
    $('.js-social-slider').slick({
      infinite: true,
      slidesToShow: 1,
      fade: true,
      autoplay: false,
      speed: 1000,
      draggable: false,
      arrows: false,
      dots: true,
    });
  }

  // Video slider used on HP
  if ($('.js-video-slider').length) {
    $('.js-video-slider').slick({
      // lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 1,
      fade: true,
      autoplay: false,
      speed: 1000,
      draggable: true,
      arrows: false,
      dots: true,
    });
  }

  /* press news loop slider */
  if ($('.js-press-slider').length) {
    $('.js-press-slider').slick({
      // lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      draggable: false,
      nextArrow: '.js-press-slider-nav-next',
      prevArrow: '.js-press-slider-nav-prev',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            draggable: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            draggable: true,
          },
        },
      ],
    });
  }

  /* press news loop slider for 4 col */
  if ($('.js-press-4col-slider').length) {
    $('.js-press-4col-slider').slick({
      // lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: false,
      nextArrow: '.js-press-4col-slider-nav-next',
      prevArrow: '.js-press-4col-slider-nav-prev',
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
            draggable: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            draggable: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            draggable: true,
          },
        },
      ],
    });
  }

  /* services news loop slider */
  if ($('.js-services-slider').length) {
    $('.js-services-slider').slick({
      // lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      draggable: false,
      nextArrow: '.js-services-slider-nav-next',
      prevArrow: '.js-services-slider-nav-prev',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            draggable: true,
          },
        },
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 1,
            draggable: true,
          },
        },
      ],
    });
  }

  /* Stories slider */
  if ($('.js-stories-slider').length) {
    var storiesSliderArgs = {
      // lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      prevArrow: false,
      nextArrow: false,
      centerMode: true,
      centerPadding: '7%',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: 'unslick',
        },
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 2,
            draggable: true,
          },
        },
      ],
    };

    // Init slick
    $('.js-stories-slider').slick(storiesSliderArgs);

    // Reslick when tabs are changed
    $('.js-stories-tabs').on('change.zf.tabs', function () {
      // Do this only for medium down
      if (!breakpointAtLeast('large')) {
        // First if slick is already initialized, destroy it
        $('.js-stories-slider.slick-initialized.is-active').slick('unslick');
        // Then reinit slick again
        $('.js-stories-slider.is-active').slick(storiesSliderArgs);
      }
    });
  }
})(jQuery);
